<template>
    <div>
      <v-card flat class="mt-0 ma-4">
        <v-card-text>
          <div class="body-1 font-weight-bold mb-3">
            Riwayat
          </div>
          <!-- <div class="d-flex align-center mb-3">
            <div>
              <v-tabs
                v-model="tabs"
                dense
                background-color="transparent"
                slider-size="5"
                color="#1814F3">
                <v-tab
                  v-for="(item, index) in tab"
                  :key="index">
                  <span
                    class="body-2 font-weight-medium text-capitalize">
                    {{ item.title }}
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider style="border-color: #EBEEF2;"></v-divider>
            </div>
          </div> -->

          <!-- <div v-if="tabs === 0">
            <PerubahanData :detailCustomer="detailCustomer" />
          </div> -->
          <div v-if="tabs === 1">
            <Plafon :detailCustomer="detailCustomer" />
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detailCustomer: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          tabs: 1,
          // tab: [
          //   { title: "Perubahan Data" },
          //   { title: "Plafon" }
          // ],
          detail: this.$route.params.id,
          process: {
            load: false,
            error: false,
            message: ""
          },
          list: [],
          paginationList: {
            page: 1,
            row: 10,
            totalPage: 0
          },
          search: "",
          selected: {
            checkbox: [],
            row: -1
          }
        };
      },
      components: {
        Plafon: () => import("@/components/customer/plafon.vue"),
        PerubahanData: () => import("@/components/customer/perubahan-data.vue"),
      },
    }
  </script>